import { Button, EmptyDescription } from "@aircall/ds";
import { useTranslation } from "react-i18next";

export function NoDataBanner({
  text,
  "data-test": dataTest,
}: {
  text: string;
  "data-test"?: string;
}) {
  const { t } = useTranslation();

  const handleOnClick = () => {
    window.open(t("call_context.learn_more_url"), "_blank");
  };

  return (
    <EmptyDescription className="font-normal" data-test={dataTest}>
      {text}
      <Button variant="link" size="lg" onClick={handleOnClick}>
        {t("call_context.learn_more_button")}
      </Button>
    </EmptyDescription>
  );
}
